import { memo } from "react";
import { Handle, Position } from "reactflow";
import PersonCard from "./PersonCard";
import { Person } from "../types/person";

interface Props {
  data: {
    person: Person;
    isEdge: boolean;
    onPersonClick?: (person: Person) => void;
    registerPosition?: (id: string, rect: DOMRect) => void;
    formatPersonSubtitle?: (person: Person) => string;
    personNodeWidth?: number;
  };
}

function PersonNode({ data }: Props) {
  const {
    person,
    isEdge,
    onPersonClick,
    registerPosition,
    formatPersonSubtitle,
    personNodeWidth,
  } = data;

  const handleClick = () => {
    onPersonClick?.(person);
  };

  return (
    <div style={{ position: "relative" }}>
      <Handle type="target" position={Position.Left} />
      <PersonCard
        person={person}
        isEdge={isEdge}
        onClick={handleClick}
        registerPosition={registerPosition}
        formatPersonSubtitle={formatPersonSubtitle}
        personNodeWidth={personNodeWidth}
      />
      <Handle type="source" position={Position.Top} />
    </div>
  );
}

export default memo(PersonNode);
